export function getGlobalObject(
// We use the filename as key; each `getGlobalObject()` call should live in a unique filename.
key, defaultValue) {
    const allGlobalObjects = (globalThis.__react_streaming = globalThis.__react_streaming || {});
    const globalObject = (allGlobalObjects[key] = allGlobalObjects[key] || defaultValue);
    return globalObject;
}
